import { Link } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { track } from "@/lib/analytics"

export function FinalCta() {
  return (
    <section className="bg-surface">
      <div className="mx-auto max-w-3xl px-4 py-20 text-center sm:px-6 sm:py-28">
        <h2 className="display-2">
          Ready to build a podcast that creates better conversations?
        </h2>
        <p className="mt-5 text-lg text-ink-body">
          Apply for a Podcast Growth Fit Call. We'll look at your offer, audience,
          and current authority position — and whether a podcast-led relationship
          strategy makes sense for your business.
        </p>
        <div className="mt-8 flex justify-center">
          <Button asChild size="lg">
            <Link href="/apply" onClick={() => track("CTA Click")}>
              Apply for a Fit Call
            </Link>
          </Button>
        </div>
      </div>
    </section>
  )
}
